import React from 'react';

function InvoiceCheckbox({ data, selected = [], onSelectChange = () => {} }) {
  if (data?.pinvInvoice?.length > 0 || !data.paid || !data.validated) {
    return null;
  }

  return (
    <input
      type="checkbox"
      checked={selected.includes(data._id)}
      onChange={(e) => {
        e.stopPropagation();
        onSelectChange(data);
      }}
    />
  );
}

export default InvoiceCheckbox;
